var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDistributorvisit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_857_4355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.1111 59.3333H7V61.1111H62.1111V59.3333Z",
    fill: "#85c225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9378 35.9022C36.5828 35.7777 36.2356 35.6322 35.8978 35.4667L35.4444 35.2267L34.6444 36.8178L35.1244 37.0578C35.5293 37.262 35.9481 37.4373 36.3778 37.5822L36.9378 35.9022Z",
    fill: "#85c225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0933 36.3378C39.5593 36.3706 39.0232 36.3498 38.4933 36.2756L38.2533 38.0533C38.69 38.1057 39.1291 38.1353 39.5689 38.1422C39.7822 38.1422 39.9955 38.1422 40.2089 38.1422L40.0933 36.3378Z",
    fill: "#85c225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0267 40.6667L18.8045 41.0489C18.9229 40.5232 19.0865 40.0087 19.2933 39.5111L17.6133 38.8889C17.3647 39.4626 17.1684 40.0576 17.0267 40.6667Z",
    fill: "#85c225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7778 42.9689C16.7765 43.4985 16.8151 44.0274 16.8933 44.5511L18.6711 44.2845C18.6017 43.8492 18.563 43.4096 18.5556 42.9689V42.6756L16.7778 42.6133C16.7778 42.7378 16.7778 42.8533 16.7778 42.9689Z",
    fill: "#85c225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8844 37.0222L21.0267 36.8622L19.7467 35.6267L19.5778 35.8133C19.2019 36.2171 18.86 36.6512 18.5555 37.1111L20.0311 38.0978C20.2844 37.7156 20.5699 37.3558 20.8844 37.0222Z",
    fill: "#85c225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6667 36.0711L42.1467 37.7778C42.7633 37.6022 43.3594 37.3608 43.9244 37.0578L43.0978 35.4844C42.6422 35.7287 42.1626 35.9253 41.6667 36.0711Z",
    fill: "#85c225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2479 33.6389L31.4528 35.2289L33.0428 36.0241L33.838 34.4341L32.2479 33.6389Z",
    fill: "#85c225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5733 32.4978L28.3689 34.2756C28.9025 34.3403 29.4291 34.4534 29.9422 34.6133L30.4756 32.9156C29.8565 32.7151 29.2194 32.5752 28.5733 32.4978Z",
    fill: "#85c225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.16 34.4444C25.6815 34.3105 26.214 34.2242 26.7511 34.1867L26.6445 32.4089C25.9962 32.4473 25.3532 32.5485 24.7245 32.7111L25.16 34.4444Z",
    fill: "#85c225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5467 32.16L48.0933 33.0489C48.4114 32.4808 48.6791 31.886 48.8933 31.2711L47.2133 30.6756C47.0378 31.1901 46.8146 31.687 46.5467 32.16Z",
    fill: "#85c225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9158 51.3658L21.5501 52.5041L22.6884 53.8697L24.054 52.7315L22.9158 51.3658Z",
    fill: "#85c225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4756 34.6045L45.5867 35.9911C46.1009 35.5848 46.5742 35.1293 47 34.6311L45.64 33.4845C45.2882 33.8938 44.8983 34.2688 44.4756 34.6045Z",
    fill: "#85c225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7111 47.3156C19.4422 46.8493 19.219 46.3581 19.0444 45.8489L17.3644 46.4356C17.577 47.0511 17.8448 47.6461 18.1644 48.2134L19.7111 47.3156Z",
    fill: "#85c225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2728 27.3371L47.74 29.0331L49.436 29.5659L49.9689 27.8699L48.2728 27.3371Z",
    fill: "#85c225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6384 48.6376L19.2727 49.7758L20.4109 51.1415L21.7766 50.0032L20.6384 48.6376Z",
    fill: "#85c225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.64 35.0045L22.9022 33.3956C22.3116 33.6623 21.7489 33.9869 21.2222 34.3645L22.2533 35.8133C22.6905 35.5028 23.1545 35.2321 23.64 35.0045Z",
    fill: "#85c225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6667 57.1111C34.6485 57.1111 35.4444 56.3152 35.4444 55.3333C35.4444 54.3515 34.6485 53.5555 33.6667 53.5555C32.6848 53.5555 31.8889 54.3515 31.8889 55.3333C31.8889 56.3152 32.6848 57.1111 33.6667 57.1111Z",
    fill: "#85c225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7778 57.1111C53.7596 57.1111 54.5556 56.3152 54.5556 55.3333C54.5556 54.3515 53.7596 53.5555 52.7778 53.5555C51.7959 53.5555 51 54.3515 51 55.3333C51 56.3152 51.7959 57.1111 52.7778 57.1111Z",
    fill: "#85c225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2222 54.8889H39.8889V45.1111H31L27.4445 49.5556V54.8889H30.1556C30.2532 54.0201 30.6674 53.2177 31.3192 52.635C31.971 52.0523 32.8146 51.7302 33.6889 51.7302C34.5632 51.7302 35.4068 52.0523 36.0586 52.635C36.7104 53.2177 37.1246 54.0201 37.2222 54.8889ZM32.7778 50.4444H29.2222V50.1778L31.8889 46.8889H32.7778V50.4444Z",
    fill: "#85c225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6667 54.8889H49.2667C49.4 54.0536 49.8267 53.2932 50.4702 52.7443C51.1138 52.1953 51.9319 51.8938 52.7778 51.8938C53.6236 51.8938 54.4418 52.1953 55.0853 52.7443C55.7288 53.2932 56.1556 54.0536 56.2889 54.8889H59.4444V43.3333H41.6667V54.8889Z",
    fill: "#85c225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1333 7.77778C58.9453 7.38776 58.6783 7.04102 58.3494 6.75949C58.0204 6.47796 57.6366 6.26777 57.2222 6.14222H57.16L56.8222 6.07111C56.6937 6.03808 56.563 6.01432 56.4311 6H56.2978C55.7107 6.001 55.1359 6.16859 54.6402 6.48328C54.1446 6.79798 53.7484 7.24686 53.4978 7.77778H50.5555V9.55556H53.2222C53.2811 10.3807 53.6654 11.1486 54.2906 11.6904C54.9157 12.2321 55.7304 12.5034 56.5555 12.4444C57.3807 12.3855 58.1486 12.0012 58.6903 11.3761C59.2321 10.751 59.5034 9.93623 59.4444 9.11111C59.4408 8.88086 59.414 8.65155 59.3644 8.42667C59.3086 8.2034 59.2312 7.98608 59.1333 7.77778Z",
    fill: "#85c225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0445 13.1111H52.92L48.6267 14.8889H44.7778C44.6599 14.8889 44.5469 14.9357 44.4635 15.0191C44.3802 15.1024 44.3333 15.2155 44.3333 15.3333V17.1911C44.3333 17.2936 44.3687 17.3929 44.4335 17.4723C44.4983 17.5516 44.5885 17.6062 44.6889 17.6267L48.6267 18.4444L52.3333 17.5556V26C52.3333 26.1179 52.3802 26.2309 52.4635 26.3143C52.5469 26.3976 52.6599 26.4444 52.7778 26.4444H61.6667C61.7846 26.4444 61.8976 26.3976 61.9809 26.3143C62.0643 26.2309 62.1111 26.1179 62.1111 26V16.6667C62.1724 15.7893 61.8845 14.9233 61.3101 14.2573C60.7356 13.5913 59.9213 13.1793 59.0445 13.1111Z",
    fill: "#85c225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2222 19.3333L42.0667 16.5689H42.12L43.4444 15.7778L42.12 15.0222H42.0667L37.2222 12.2222V6H7V27.3333H37.2222V19.3333ZM35.4444 25.5556H8.77778V7.77778H35.4444V13.3244L39.6756 15.7778L35.4444 18.2311V25.5556Z",
    fill: "#85c225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8889 19.7156L21.2222 22V15.9022L15.8889 13.6178V19.7156Z",
    fill: "#85c225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1111 22L27.4444 19.7156V13.6178L22.1111 15.9022V22Z",
    fill: "#85c225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6667 10.4444L16.3333 12.7289L21.6667 15.0133L27 12.7289L21.6667 10.4444Z",
    fill: "#85c225"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_857_4355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(7 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistributorvisit);
export default __webpack_public_path__ + "static/media/Distributor visit.c8cac70150526da411ee86d572529d6a.svg";
export { ForwardRef as ReactComponent };